/**
 * Wires "Gift terms" triggers ([data-gift-terms-trigger]) on the PDP:
 * lazy-loads the full Terms of Service policy content from a standalone
 * section via the Shopify Section Rendering API on first click, then
 * toggles the expandable scrollable panel on subsequent clicks.
 *
 * Loaded by layout/theme.liquid on product pages.
 */

document.addEventListener('click', async (event) => {
  if (!(event.target instanceof Element)) return;

  const trigger = event.target.closest<HTMLElement>('[data-gift-terms-trigger]');
  if (!trigger) return;

  const panel = trigger.parentElement?.querySelector<HTMLElement>('[data-gift-terms-panel]');
  if (!panel) return;

  // If content is already loaded, just toggle visibility.
  if (panel.dataset.loaded === 'true') {
    const isExpanded = trigger.getAttribute('aria-expanded') === 'true';
    trigger.setAttribute('aria-expanded', String(!isExpanded));
    panel.hidden = isExpanded;
    return;
  }

  // First click: fetch the section content via the Section Rendering API.
  const sectionId = trigger.getAttribute('data-section-id');
  if (!sectionId) return;

  trigger.disabled = true;

  try {
    const url = `${window.Shopify.routes.root}?sections=${encodeURIComponent(sectionId)}`;
    const res = await fetch(url, {
      method: 'GET',
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    });

    if (!res.ok) return;

    const json = (await res.json()) as Record<string, string>;
    const html = json[sectionId];
    if (!html) return;

    panel.innerHTML = html;
    panel.dataset.loaded = 'true';
    panel.hidden = false;
    trigger.setAttribute('aria-expanded', 'true');
  } finally {
    trigger.disabled = false;
  }
});
